
<template>
<markdown-render v-if="guide" :source="guide"></markdown-render>
</template>

<script>
import { mapState } from 'vuex'
import MarkdownRender from '../../MarkdownRender'

export default {
  components:{
    "markdown-render": MarkdownRender
  },

  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env]
      }
    )
  },
  data(){
    return {
      guide: null
    }
  },

  mounted(){
    this.guide = guide;
  }
  
}



const guide = "                                                                     \n\
# Getting started for FP-ATR-SIGOFOX1                                              \n\
Please follow instructions [from here](https://www.st.com/en/embedded-software/fp-atr-sigfox1.htm) in order to configure properly your device \n\
## Sigfox backend                                                                   \n\
1. Activate device from Sigfox [activation page](https://buy.sigfox.com/activate) \n\
2. Login in your Sigfox [backend account](https://backend.sigfox.com/auth/login)  \n\
3. Create a new API ACCESS (with all permissions) under device group created at activation time \n\
4. Get credentials (`Login` and `Password`) automatically generated                     \n\
![img](/assets/howto/sigfoxcreategroup.png =500x)                                         \n\
##  Provision device on asset-tracking dashboard                                                                \n\
1. Create and get an api-key from **settings** view  \n\
2. To simplify the device provisioning, create a Sigfox device profile from **settings** view by using `Login` and `Password` parameters got previously   \n\
3. From **devices** view regiester a new *FP-ATR-SIGFOX1* device by providing:\n\
    - Human-friendly label\n\
    - Device ID (used for previous registration)\n\
    - Api-key (previously created)\n\
    - Device profile (previously created)\n\
"
</script>